import QRCode from "qrcodejs2";
export default {
    data() {
        return {
          loading:false,
          giftList: [],
          activityData: {},
      }  
    },
  async created() {
      this.activityData = this.handleRouteType();
      this.$nextTick(() => {
          this.getCodeIMG();
      });
    },
  methods: {
      handleRouteType() {
        let activityType = this.$route.query.activityType * 1;
        console.log(activityType,22222)
        let data = {};
        switch (activityType) {
          case 25:
            data.activityID = activityType;
            data.title = "智能活动海报";
            data.content = "互动、品牌等活动通过smartCard小部件的形式在店铺首页展示，并且支持轮播的方式切换活动查看，点击“参与活动”跳转到相应的活动页面；展示的信息主要是主图、活动名称、倒计时、参与人数等，通过倒计时的方式给用户营造紧迫感，促使用户参与活动";
            data.src = '';
            data.bghome = 'https://cdn-image.yucrm.cn/images/jd-front-platform/thdImg/active/hd1.png';
            data.path = 'smartPoster'
            data.codeUrl = 'https://yq-hd-rc.isvjcloud.com/templateCommon?templateImg=https://jdminiapp.yucrm.cn/html/images/Preview/znhb.png'
            data.course = 'https://www.yuque.com/yunduanxincrm/flgan6/cycrgootst0fsvaq'
            break;
          case 26:
            data.activityID = activityType;
            data.title = "刮刮乐";
            data.content = "刮刮乐抽奖 以smartCard小部件的方式在店铺首页展示，用户直接在首页参与抽奖活动,无需跳转特定的活动页，减少访问路径,提升流量承就效率";
            data.src = '';
            data.bghome = "https://cdn-image.yucrm.cn/images/jd-front-platform/thdImg/active/ggl1.png";
            data.path = 'scratchers'
            data.codeUrl = 'https://yq-hd-rc.isvjcloud.com/templateCommon?templateImg=https://jdminiapp.yucrm.cn/html/images/Preview/ggl.png'
            data.course = 'https://www.yuque.com/yunduanxincrm/flgan6/un9uye0ib22zh7ut'
            break;
          case 32:
            data.activityID = activityType;
            data.title = "会员卡片";
            data.content = "会员身份资产信息以模块化的形式在店铺首页展示，针对未入会用户显示会员权益，吸引用户入会，为店铺拉新引流。 针对已入会的会员则显示阶段会员成长体系和专属权益进一步引导会员升级，增强会员粘性；";
            data.src = '';
            data.bghome = "https://cdn-image.yucrm.cn/images/jd-front-platform/thdImg/active/kapian.png";
            data.path = 'memberCard'
            data.codeUrl = 'https://yq-hd-rc.isvjcloud.com/templateCommon?templateImg=https://yeion-public.s3.cn-north-1.jdcloud-oss.com/jhk_C/kapian.png'
            data.course = 'https://www.yuque.com/yunduanxincrm/flgan6/cy4mp6nx5zeb040d'
            break;
          case 33:
            data.activityID = activityType;
            data.title = "0元试用";
            data.content = "将0元试用玩法以模块化的形式在店铺首页呈现，用户直接在店铺即可完成试用预约，增强活动曝光度以及提升用户参与度。";
            data.src = '';
            data.bghome = "https://cdn-image.yucrm.cn/images/jd-front-platform/thdImg/active/0yuan.png";
            data.path = 'freeTrial'
            data.codeUrl = 'https://yq-hd-rc.isvjcloud.com/templateCommon?templateImg=https://yeion-public.s3.cn-north-1.jdcloud-oss.com/jhk_C/0yuan.png'
            data.course = 'https://www.yuque.com/yunduanxincrm/flgan6/oscg0u281aqhwgzk'
            break;
        }
        console.log(data,33333333333333333333333333)
        return data;
      },
        handleTem(item, index) {
            console.log(item,99999666);
            this.tempIndex = index;
            this.tempItem = item;
            this.getPolite();
        },

        // 生成二维码
        getCodeIMG() {
          const url = this.activityData.codeUrl;
          if (this.$refs.QRcode_img) {
              this.$refs.QRcode_img.innerHTML = "";
          
              new QRCode('QRcode_img', {
                errorCorrectionLevel:'H',//容错级别 L M Q H
                width: 134, // 设置宽度，单位像素
                height: 134, // 设置高度，单位像素
                // text: url, // 设置二维码内容或跳转地址
                text: url,
              });
          }
          if (this.$refs.qrCodeIMG) {
            this.$refs.qrCodeIMG.innerHTML = "";
             new QRCode('qrCodeIMG', {
                errorCorrectionLevel:'H',//容错级别 L M Q H
                width: 150, // 设置宽度，单位像素
                height: 150, // 设置高度，单位像素
                // text: url, // 设置二维码内容或跳转地址
                text: url,
            });
          }

        },
        // 生成二维码
        getCodeIMG1() {
          
            // const codeImg = document.querySelectorAll(".qrCodeIMG");
          const url = this.activityData.codeUrl;
            new QRCode('qrCodeIMG1', {
                errorCorrectionLevel:'H',//容错级别 L M Q H
                width: 150, // 设置宽度，单位像素
                height: 150, // 设置高度，单位像素
                // text: url, // 设置二维码内容或跳转地址
                text: url,
            });
        },
        // 限免日期
        getDaysBetween(dateString1, dateString2) {
            const startDate = Date.parse(dateString1);
            const nowDate = Date.parse(new Date());
            const endDate = Date.parse(dateString2);
            if (startDate > endDate) {
                return 0;
            }
            if (startDate == endDate) {
                return 1;
            }
            let days = 0;
            if (nowDate > startDate) {
                days = (endDate - nowDate) / (1 * 24 * 60 * 60 * 1000);
            } else {
                days = (endDate - startDate) / (1 * 24 * 60 * 60 * 1000);
            }
            return Math.floor(days) == 0 ? "1天" : Math.ceil(days) + "天";
        },

    }
}